import { serve } from '@wix/communication-channel';
import type { ProviderAPI } from './types';

export { handshakeCode } from '@wix/communication-channel';

export * from './types';

interface ProvideParams {
  api: ProviderAPI;
  port: MessagePort;
}
export function provideSDKApi({ api, port }: ProvideParams) {
  serve({ api, port });
}
